<template>
    <div>
        <div class="crumbs" hidden="true" style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 分销管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>等级配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover"  class="searchCard" >
            <div class='circleNumDiv'>
                <p class='circleNumP'>
                    <span class='circle1'>{{workData.waitNum1}}</span>
                </p>
                <p class='circleNumP'>
                    <span class='circle1'>{{workData.checkNum1}}</span>
                </p>
            </div>
            <span class="label-span">
                <label class="label">投诉时间</label>
                <el-date-picker v-model="query.startTime" value-format='yyyy-MM-dd' placeholder="开始日期" style="width:130px;"> </el-date-picker>
                <el-date-picker v-model="query.endTime" value-format='yyyy-MM-dd' placeholder="结束日期" style="width:130px;" class="mr10"> </el-date-picker>
            </span>
            <span class="label-span">
                    <label class="label">涉及业务</label>
                    <el-select v-model="query.goodsCode"  placeholder="涉及业务" clearable class="handle-input mr10">
                        <el-option v-for="item in select.option"  :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </span>
            <span class="label-span">
                    <label class="label">投诉类型</label>
                    <el-select v-model="query.tsId"  placeholder="投诉类型" clearable class="handle-input mr10">
                        <el-option key="item.id" label="全部" value="" />
                        <el-option v-for="item in select2.option"  :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </span>
            <span class="label-span">
                    <label class="label">工单等级</label>
                    <el-select v-model="query.level"  placeholder="投诉类型" clearable class="handle-input mr10">
                        <el-option key="item.id" label="全部" value="" />
                        <el-option key="item.id" label="常规" value="1" />
                        <el-option key="item.id" label="紧急" value="2" />
                    </el-select>
                </span>

            <span class="label-span">
                    <label class="label">投诉号码</label>
                <el-input v-model.trim="query.phone" placeholder="投诉号码"  class="handle-input mr10"></el-input>
                </span>
            <span class="label-span">
                    <label class="label">投诉地市</label>
                <el-input v-model.trim="query.city" placeholder="投诉地市"  class="handle-input mr10"></el-input>
                </span>
            <el-button type="success" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button type="error" icon="el-icon-refresh"  @click="refreshSearch">重置</el-button>
        </el-card>
        <el-card  shadow="hover"  class="containCard" >
            <el-table :data="tableData" border size="small" class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column prop="id" width="80" align="center" label="ID"></el-table-column>
                <el-table-column prop="woType"  min-width="220" align="left" label="工单信息">
                    <template slot-scope="scope">
                        <p class='size12'>
                            工单等级：<el-tag :type="scope.row.level==2?'danger':'primary'">{{scope.row.level==2?'紧急':'常规'}}</el-tag><br>
                            投诉号码：<el-link type='primary' @click='copyText(scope.row.phone)'>{{scope.row.phone}}</el-link><el-tag style='margin-left:10px' type='info'>{{scope.row.city}}</el-tag><br>
                            联系号码：<el-link type='primary' @click='copyText(scope.row.phone2)'>{{scope.row.phone2}}</el-link>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="woType"  min-width="200" align="left" label="业务信息">
                    <template slot-scope="scope">
                        <p class='size12'>
                            投诉类型：<span v-for="item in select2.option" v-if='scope.row.tsId==item.optKey'>{{item.optVal}}</span><br>
                            涉及业务：<el-link @click='copyText(scope.row.tsContent)' style='font-size:12px;' v-for="item in select.option" v-if='scope.row.goodsCode==item.optKey'>{{item.optVal}}</el-link>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="tsContent" min-width="300" align="left" label="投诉内容">
                    <template slot-scope="scope">
                        <div v-if="scope.row.tsContent!=null && scope.row.tsContent!=''">
                            <el-popover  placement="bottom" title="投诉内容"  width="600" trigger="hover" :content="scope.row.tsContent">
                                <el-link slot="reference" @click='copyText(scope.row.tsContent)' style='font-size:12px;line-height: 20px;webkit-line-clamp: 3;-webkit-box-orient: vertical;display: -webkit-box;overflow:hidden;text-overflow: ellipsis;'>{{scope.row.tsContent}}</el-link>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="woType" min-width="180" align="left" label="处理方案">
                    <template slot-scope="scope">
                        <p class='size12'>
                            是否退费：{{scope.row.isCash==0?'仅退订':scope.row.isCash==1?'已退费':'-'}}<b v-if='scope.row.isCash==1' class='red ml10'>￥{{scope.row.handleCash}}</b><br>
                            处理方案：{{scope.row.handleContent}}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="woType" min-width="150" align="left" label="处理凭证">
                    <template slot-scope="scope">
                        <p class='size12'>
                            订购凭证：<el-link @click='showImgs(scope.row.handleImgs)' style='font-size:12px;' type='success' v-if="scope.row.handleImgs!=null && scope.row.handleImgs.length>0"><i class='el-icon-lx-attention'></i> 查看凭证</el-link>
                            <span v-else>无</span><br>
                            处理凭证：<el-link @click='showFiles(scope.row.handleFiles)' style='font-size:12px;' type='success' v-if="scope.row.handleFiles!=null && scope.row.handleFiles.length>0"><i class='el-icon-lx-attention'></i> 查看凭证</el-link>
                            <span v-else>无</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="woType" min-width="200" align="left" label="业务时间">
                    <template slot-scope="scope">
                        <p class='size12'>
                            投诉时间：{{scope.row.tsDay}}<br>
                            订购时间：{{scope.row.orderTime}}<br>
                            工单时间：{{scope.row.createTime}}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="110" align="center"  fixed="right">
                    <template slot-scope="scope" >
                        <el-tooltip class="item" effect="light" content="倒计时结束后工单自动完结" placement="bottom-end">
                            <p :class="'red cursor mb15 woInterval'+scope.row.id">{{ woInterval(this,'.woInterval'+scope.row.id,scope.row.updateTime) }}</p>
                        </el-tooltip>
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 工单审批</span><br>
<!--                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-lx-roundclose'></i> 撤销工单</span>-->
                    </template>
                </el-table-column>

            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-card>
        <!-- 新建绑定弹出框 -->
        <el-dialog :close-on-click-modal="false" title="工单录入" :modal-append-to-body='false' :visible.sync="addVisible" width='520px'    >
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item required label="投诉类型" >
                    <el-radio-group v-model.trim="form1.tsId" >
                        <el-radio-button v-for="item in select2.option" :label="item.optKey">{{ item.optVal }}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item required label="投诉号码" class='wid50'>
                    <el-input oninput="value=value.replace(/[^\d]/g,'')" @change='overlength' v-model.trim="form1.phone" placeholder=""></el-input>
                </el-form-item>
                <el-form-item required label="投诉时间" class='wid50'>
                    <el-date-picker v-model="form1.tsDay" value-format='yyyy-MM-dd' placeholder="投诉时间" style="width:100%;"> </el-date-picker>
                </el-form-item>
                <el-form-item required label="涉及业务">
                    <el-select v-model="form1.goodsCode"  placeholder="资源状态" clearable class="wid100">
                        <el-option v-for="item in select.option"  :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item required label="工单内容">
                    <el-input type="textarea" placeholder="请填写工单内容" :rows="5" v-model.trim="form1.tsContent" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog :close-on-click-modal="false" title="工单审批" :modal-append-to-body='false' :visible.sync="editVisible"  width='660px' top='80px'  >
            <h3><i class='el-icon-s-check theme'></i> 处理流程</h3><br>
            <div class='handleDiv' >
                <el-timeline style='margin-left:10px;'>
                    <el-timeline-item
                        v-for="(item, index) in replyList"
                        :key="index" >
                        <el-tag>{{item.status==1?'工单创建':item.status==2?'工单处理':item.status==-1?'审批拒接':item.status==9?'工单完结':'-'}}</el-tag>
                        <span v-if='item.status==2'><el-tag type='danger' class='ml10'>{{item.isCash==0?'仅退订':item.isCash==1?'已退费':'-'}}<b v-if='item.isCash==1' > - ￥{{item.cash}}</b></el-tag></span>
                        <span class='ml10' style='color:#777'>{{item.createTime}}</span>
                        <br>
                        <div class='ml10 mt5' v-if="item.content!=null && item.content!=''">
                            <el-link v-if='item.status==1' style='font-size:12px;line-height: 20px;'>工单内容：{{item.content}}</el-link>
                            <div v-if='item.status==2'  style='font-size:12px;line-height: 20px;'>
                                    处理方案：{{item.content}}<br>
                                   <div v-if=' item.imgs!=null '> 订购凭证：
                                        <img  v-for='url in item.imgs.split(",")' @click='seeImg(url)' :src='url' style='vertical-align:bottom;margin-right:10px;width:50px'   />
                                    </div>
                                    <div style='margin-top:5px;' v-if=' item.fileList!=null '>处理凭证：
                                        <span v-for='item2 in  item.fileList'>
                                           <img v-if="/\.(jpg|png|gif|jpeg)$/i.test(item2.fileName)"  @click='seeImg(item2.filePath)' :src='item2.filePath' style='vertical-align:bottom;margin-right:10px;width:50px;'   />
                                           <span v-else class='cursor mr10' @click="seeImg(item2.filePath)">{{item2.fileName}}  &nbsp;&nbsp;<i class='el-icon-lx-down theme'  ></i></span>
                                        </span>
                                    </div>
                            </div>
                            <el-link v-if='item.status==-1 || item.status==9'  style='font-size:12px;line-height: 20px;'>
                                审批说明：{{item.content}}
                             </el-link>

                        </div>

                    </el-timeline-item>
                </el-timeline>
            </div>
            <br><h3><i class='el-icon-s-check red'></i> 审批结果</h3><br>
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item required label="审批结果" class='wid50'>
                    <el-radio-group v-model.trim="form.status" >
                        <el-radio-button  label="9">工单完结</el-radio-button>
                        <el-radio-button  label="-1">审批拒接</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="审批说明" >
                    <el-input type="textarea" placeholder="请填写审批说明,非必填" :rows="3" v-model.trim="form.content" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer"  class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveHandle">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="查找图片" :modal-append-to-body='false' :visible.sync="showVisible" top="50px" width="1020px">
            <div style="width:100%;height:600px;overflow-y:scroll;margin-top:-30px;">
                <v-content3 ></v-content3>
            </div>
        </el-dialog>
        <el-dialog :modal-append-to-body='false' title=""  :visible.sync="dialogVisible" width="380px" top="50px">
            <img width="100%" :src="dialogImageUrl" alt="" style="width:340px;margin-top:15px;">
        </el-dialog>

        <el-dialog :modal-append-to-body='false' title="订购凭证"  :visible.sync="dialogVisible2" width="400px" top="50px">
            <div>
                <span v-for='item in dialogImageUrls' style='text-align: center'>
                    <el-button style="background:rgb(0,0,0,0.5) !important;float:right;color:#fff !important" @click="downFile(item)">下载</el-button><br>
                    <br><img width="100%"  :src="item" alt="" style="width:360px;border:1px solid #ddd;margin-top:0px;margin-bottom:20px;">
                </span>
                <div style='clear:both'></div>
            </div>
        </el-dialog>
        <el-dialog :modal-append-to-body='false' title="处理凭证"  :visible.sync="dialogVisible3" width="400px" top="80px">
            <div style='padding:15px 0'>
                <div class='fileChooseList' v-for="(item,index) in dialogFiles" :key="index">
                    <p v-if="/\.(jpg|png|gif|jpeg)$/i.test(item.fileName)" class='fileChooseList-text'>
                        <img :src='item.filePath' style='width:100%;'>
                    </p>
                    <p v-else class='fileChooseList-text'>{{item.fileName}}</p>
                    <p class='fileChooseList-i'>
                        <el-tooltip class="item" effect="light" content="下载" placement="bottom-end">
                            <i class='el-icon-lx-down' @click="seeFile(item)" ></i>
                        </el-tooltip>
                    </p>
                </div>
                <div style='clear:both'></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { woInterval } from '@/utils/countDown';
import {fetchData, saveForm, handDelete, updateHandle, getStateDetail,getReplayList,getWorkOrderShow2 as getWorkOrderShow  } from './woHandle';
import {fetchSelect3 as fetchSelect } from '../../api/comGoods';
import {fetchSelect as fetchSelect2} from '../../api/tsType';
import bus from '../../components/common/bus';
import vContent3 from '../../view/system/sysConfig/ComImg.vue';
import { fetchSelect as fetchSelect1 } from '@/api/comGoodsDoc';
import { changeStatus } from '@/api/goodsFrom';
import { quillEditor } from 'vue-quill-editor';
import vContent1 from '@/components/page/ComGoodsLimit.vue';
import vContent2 from '@/view/goods/ComGoodsMemConfig.vue';
export default {
    name: 'memGrade',
    data() {
        return {
            workData:{},
            replyList:[],
            replyName:'回复',
            stationLogo:'',
            stationName:'',
            avatar:'',
            username:'',
            select:{option:'',},
            select2:{option:'',},
            query: {
                pageIndex: 1,
                pageSize: 10,
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible:false,
            pageTotal: 0,
            form: {
            },
            form1: {
                woType:1,
            },
            idx: -1,
            id: -1,
            dialogImageUrl:'',
            dialogVisible:false,
            dialogImageUrls:'',
            dialogFiles:'',
            dialogVisible2:false,
            dialogVisible3:false,
            showVisible:false,
            img:[],
        };
    },
    components: {
        vContent3,
    },
    created() {
        bus.$on('image-choose',  url  => {
            this.img.push(url)  //通过添加array的值，增加input的个数
            this.showVisible = false;
        });
    },
    //页面加载方法
    mounted() {
        this.getSelect();
        this.getSelect2();
        this.getData();
        this.getWorkOrderShow();
    },
    methods: {
        getWorkOrderShow(){
            getWorkOrderShow({ }).then(res => {
                if(res.code=='200'){
                    this.workData = res.data;
                }
            });
        },
        woInterval,
        seeFile(file) {
            window.open(file.filePath);
        },
        addImg(){
            this.showVisible=true;
        },  seeImg(url) {
            if(/\.(jpg|png|gif|jpeg)$/i.test(url)){
                this.dialogImageUrl = url;
                this.dialogVisible = true;
            }else{
                window.open(url);
            }
        },
        showImgs(urls){
            this.dialogImageUrls = urls.split(",");
            this.dialogVisible2 = true;
        },
        showFiles(file){
            this.dialogFiles = JSON.parse(file);
            this.dialogVisible3 = true;
        },
        delImg(index,i){
            this.img.splice(index,1);   //先删除form中value对应索引的值
        },
        copyText(text){
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);
            //提示已复制
            this.$message.success("内容已复制");
        },
        //获取下拉框数据
        getSelect(){
            this.select = {};
            this.select.channelCode = '46';
            fetchSelect(this.select).then(res => {
                if(res.code=='200'){
                    this.$set(this.select, 'option', res.data);
                }
            });
        },
        getSelect2(){
            this.select2 = {};
            fetchSelect2(this.select2).then(res => {
                if(res.code=='200'){
                    this.$set(this.select2, 'option', res.data);
                }
            });
        },
        downFile(url) {
            let fileUrl = url  //服务器文件地址
            this.getBlob(fileUrl).then(blob => {
                this.saveAs(blob, '处理凭证')
            })
        },
        //通过文件下载url拿到对应的blob对象
        getBlob(url) {
            return new Promise(resolve => {
                const xhr = new XMLHttpRequest()
                xhr.open('GET', url, true)
                xhr.responseType = 'blob'
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        resolve(xhr.response)
                    }
                }

                xhr.send()
            })
        },
        //下载文件
        saveAs(blob, filename) {
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.click()
        },
        overlength(){
            if(this.form1.phone.length>11){
                this.$message.error("投诉号码不超过11位");
            }
            if(this.form1.phone.length<11){
                this.$message.error("投诉号码不少于11位");
            }
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        //刷新
        refresh(){
            history.go(0);
        },
        //重置
        //重置按钮
        refreshSearch(){
            this.$set(this.query, 'startTime');
            this.$set(this.query, 'endTime');
            this.$set(this.query, 'goodsCode');
            this.$set(this.query, 'tsId');
            this.$set(this.query, 'phone');
            this.$set(this.query, 'city');
            this.$set(this.query, 'level');
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
            //清空下拉框
        },
        //查询
        getData(){
            this.query.status='2';
            fetchData(this.query).then(res => {
                if(res.code=='200'){
                    this.getWorkOrderShow();
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;
                }else{
                    this.tableData = [];
                    this.pageTotal = 0;
                }
            });
        },
        // 关闭订单
        handDelete(index, row) {
            this.$confirm("确定要撤销此工单吗？", '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){
                        this.$message.success('撤销成功');
                        this.getData();
                        Bus.$emit("getData");
                    }else if(res.code=='201'){
                        this.$message.error("撤销异常："+res.message);
                    }
                });
            }).catch(() => {});

        },
        // 多选操作

        // 新增绑定
        addBind() {
            this.addVisible = true;
        },
        //保存新增
        saveForm() {
            if( !this.form1.tsId){
                this.$message.error("请选择投诉类型");
                return;
            }
            if( !this.form1.phone ){
                this.$message.error("请选择投诉号码");
                return;
            }if( this.form1.phone.length!=11 ){
                this.$message.error("投诉号码不正确，必须等于11位");
                return;
            }
            if( !this.form1.tsDay){
                this.$message.error("请选择投诉时间");
                return;
            }
            if( !this.form1.goodsCode){
                this.$message.error("请选择投诉业务");
                return;
            }
            if( !this.form1.tsContent){
                this.$message.error("请填写工单内容");
                return;
            }
            this.addVisible = false;
            saveForm(this.form1).then(res => {
                if(res.code=='200'){
                    this.$message.success(res.message);
                    this.getData();
                    Bus.$emit("getData");
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        // 编辑操作
        handleEdit(index, row) {
            let data = {};
            data.sid = row.id;
            getStateDetail(data).then(res => {
                if(res.code=='200'){
                    this.form = row;
                    this.replyList = res.data;
                    this.form.status = 9;
                    this.editVisible = true;
                }else{
                    this.$message.error(res.message);
                }
            });

        },
        // 保存编辑
        saveHandle() {
            this.form.reply = '1';
            this.editVisible = false;
            updateHandle(this.form).then(res => {
                if(res.code=='200'){
                    this.getData();
                    this.$message.success("处理成功");
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>
<style>

</style>

<style scoped>
.handleDiv{
    width:96%;background:#fff;padding:15px 10px;height:220px;
    border:1px dashed #aaa;border-radius:5px;overflow-y: scroll;
}
.handleDiv::-webkit-scrollbar {
    width: 6px;       /* 竖向宽度 */
    height: 5px;      /* 横向高度（可选） */
}
.handleDiv::-webkit-scrollbar-thumb{
    background: #bbb;
    border-radius: 3px; /* 圆角建议≤1px避免溢出 */
}
@media screen and (max-width:999px){
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 10px;
    }
    .el-dialog,.el-dialog--center{
        width:315px;
    }
    .el-dialog__header {
        padding: 10px 10px 0px;
    }
    .btnCss{
        height:40px;
        margin-left:10px;
    }
    .handle-del {
        float:left;
        margin-top:10px;
        margin-left:10px;
        margin-right:10px;
    }
}
@media screen and (min-width:999px){
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 25px 25px 30px;
    }
    .el-dialog__header {
        padding: 20px 20px 0px;
    }

    .el-dialog,.el-dialog--center{
        width:560px;
    }
    .btnCss{

        display:inline-block;
    }
    .handle-del {
        float:right;
    }
}



.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
